module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasLoading) ? _c('div', [_c('div', {
    staticClass: "loading-page"
  }), _vm._v(" "), _c('spinner', {
    attrs: {
      "message": "Loading...",
      "text-fg-color": "#000",
      "line-fg-color": "#423799",
      "line-bg-color": "#555555"
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08dc7044"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoadingPage.vue
// module id = 1768
// module chunks = 1